module.exports = __webpack_public_path__ + "static/media/dentist.d470dab9.svg";